import React from 'react';
import { cn } from '../../../components/ui/_cn';

// The mock's page-number window (spec 2026-09-21 §5.3): "1 2 3 4 … N" while
// the reader is near the front, "1 … N-3 N-2 N-1 N" near the back, and
// "1 … c-1 c c+1 … N" in between; the current page is always drawn.
export const pageWindow = (page, pageCount) => {
  if (pageCount <= 5) return Array.from({ length: pageCount }, (_, i) => i + 1);
  if (page <= 4) return [1, 2, 3, 4, '…', pageCount];
  if (page >= pageCount - 3) return [1, '…', pageCount - 3, pageCount - 2, pageCount - 1, pageCount];
  return [1, '…', page - 1, page, page + 1, '…', pageCount];
};

const base = 'h-[30px] min-w-[30px] rounded-md px-2 text-[12.5px] font-semibold';

const OrderReportPager = ({ page, pageCount, onChange }) => (
  <nav aria-label="Order report pages" className="flex items-center gap-1">
    <button
      type="button"
      disabled={page <= 1}
      onClick={() => onChange(page - 1)}
      className={cn(base, 'border', page <= 1 ? 'border-fin-border text-fin-chrome' : 'border-fin-border-2 text-fin-ink hover:bg-fin-recess')}
    >
      Previous
    </button>
    {pageWindow(page, pageCount).map((entry, i) =>
      entry === '…' ? (
        <span key={`gap-${i}`} className={cn(base, 'inline-flex items-center justify-center text-fin-faintest')}>…</span>
      ) : (
        <button
          key={entry}
          type="button"
          aria-current={entry === page ? 'page' : undefined}
          onClick={() => onChange(entry)}
          className={cn(
            base, 'border tabular-nums',
            entry === page ? 'border-fin-blue bg-fin-selected text-fin-ink' : 'border-transparent text-fin-muted-2 hover:bg-fin-recess',
          )}
        >
          {entry}
        </button>
      ),
    )}
    <button
      type="button"
      disabled={page >= pageCount}
      onClick={() => onChange(page + 1)}
      className={cn(base, 'border', page >= pageCount ? 'border-fin-border text-fin-chrome' : 'border-fin-border-2 text-fin-ink hover:bg-fin-recess')}
    >
      Next
    </button>
  </nav>
);

export default OrderReportPager;
